import * as React from "react";
import "./reconciliationModal.scss"
import _ = require("underscore");

interface IProps {
	question: string;
	yesOptionLabel: string;
	noOptionLabel: string;
	yesOptionCallback: () => void;
	noOptionCallback: () => void;
}

export const ConfirmReconcilePopup: React.SFC<IProps> = (props) => {
	return (
		<div className="c-reconciliation-modal_reconcile-popup">
			<span className="c-reconciliation-modal_reconcile-popup_question">{props.question}</span>
			<span className="c-reconciliation-modal_reconcile-popup_link" onClick={_.throttle(props.yesOptionCallback, 300)}>
					{props.yesOptionLabel}
			</span>
			<span className="c-reconciliation-modal_reconcile-popup_link" onClick={props.noOptionCallback}>
				{props.noOptionLabel}
			</span>
		</div>
	);
};
